/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';

// Material Dashboard 2 PRO React TS components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// Billing page components
import DashboardLayout from 'composites/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'composites/Navbars/DashboardNavbar';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Types
import { PaymentStatusResponse } from '../../../packages/crypto-payments/src/models/types';
import { useUser } from 'context/user';
import DataTable from 'composites/Tables/DataTable';
import dataTableData from './dataTableData';
import { CRYPTO_PAYMENTS_API_URL } from 'config';

function Credits(): JSX.Element {
  const [transactions, setTransactions] = useState<PaymentStatusResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { user, accessToken } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTransactions = async () => {
      if (!user) return;

      try {
        const response = await fetch(
          `${CRYPTO_PAYMENTS_API_URL}/api/crypto/payments?accessToken=${accessToken}`
        );

        if (!response.ok) {
          throw new Error('Failed to fetch transactions');
        }

        const data = await response.json();
        setTransactions(data.payments || []);
      } catch (error) {
        console.error('Error fetching transactions:', error);
      } finally {
        setLoading(false);
      }
    };

    if (accessToken) {
      fetchTransactions();
    }
  }, [accessToken]);

  const handleTopUp = () => {
    navigate('/top-up');
  };

  const tableData = dataTableData(transactions);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={4}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  pt={2}
                  px={2}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h6" fontWeight="medium">
                    Your Transactions
                  </MDTypography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleTopUp}
                  >
                    Top Up Credits
                  </Button>
                </MDBox>
                <MDBox p={2}>
                  <DataTable table={tableData} canSearch />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Credits;
